import { ReactNode } from 'react';

import { ServiceListType, WithdrawalReasonType } from './types';

export const UPDATED_RESET_EMAIL_VERSION = '8.74.0';
export const SERVICE_LIST: ServiceListType[] = ['zigzag', 'fbk', 'posty', 'kitto'];

export const WITHDRAWAL_REASON_LIST: Array<{ label: ReactNode; value: WithdrawalReasonType; reason: string }> = [
  {
    label: '원하는 스토어가 없어요.',
    value: 'store',
    reason: '원하는 스토어가 없어요.',
  },
  { label: '오류가 자주 생겨요.', value: 'error', reason: '오류가 자주 생겨요.' },
  {
    label: '과도한 쇼핑을 자제하고 싶어요.',
    value: 'lavish',
    reason: '과도한 쇼핑을 자제하고 싶어요.',
  },
  {
    label: '쿠폰/포인트 등의 혜택이 너무 적어요.',
    value: 'benefit',
    reason: '쿠폰/포인트 등의 혜택이 너무 적어요.',
  },
  {
    label: '다른 계정으로 다시 가입하고 싶어요.',
    value: 'rejoin',
    reason: '다른 계정으로 다시 가입하고 싶어요.',
  },
  { label: '직접 입력', value: 'direct', reason: '직접 입력' },
];

export const WITHDRAWAL_REASON_MAP: Record<
  WithdrawalReasonType,
  { title: ReactNode; description: (user_name: string) => ReactNode; action_name: ReactNode }
> = {
  store: {
    title: '원하는 스토어는 고객센터로 알려주세요.',
    description: () => (
      <>
        보고 싶은 스토어가 있다면 알려주세요.
        <br />더 빨리 입점될 수 있도록 할게요.
      </>
    ),
    action_name: '고객센터 문의하기',
  },
  error: {
    title: '고객센터로 문의해 주세요.',
    description: () => '불편하셨던 점을 알려주시면 빠르게 도와드릴게요.',
    action_name: '고객센터 문의하기',
  },
  lavish: {
    title: '탈퇴 대신 잠시 쇼핑을 줄이는 건 어때요?',
    description: () => '탈퇴하면 이용하신 기록과 혜택이 모두 사라져요.',
    action_name: '계정 유지',
  },
  benefit: {
    title: '원하는 혜택이 있나요?',
    description: () => '고객센터로 알려주시면 더 좋은 혜택을 위해 노력할게요.',
    action_name: '고객센터 문의하기',
  },
  rejoin: {
    title: '이메일만 바꿀 수 있어요.',
    description: () => '혜택과 포인트는 유지하고 계정만 변경할 수 있어요.',
    action_name: '이메일 변경하러 가기',
  },
  direct: {
    title: '',
    description: () => '',
    action_name: '',
  },
};
